import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import DisclaimerTicker from './DisclaimerTicker';
import InnerPageWrapper from './InnerPageWrapper';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Header />
      <main className={cn(
        "flex-1 pb-[90px] md:pb-0",
        isHome ? "pt-[90px]" : "pt-[80px]"
      )}>
        {isHome ? children : <InnerPageWrapper>{children}</InnerPageWrapper>}
      </main>
      <Footer />
      <WhatsAppButton />
      <DisclaimerTicker />
    </div>
  );
};

export default Layout;
